import { I18n } from "@assets/strings";
import React from "react";
import { GroupType } from "@domain/group/group";
import { GroupMember } from "@domain/group/groupMember";
import { useGroupMember } from "@domain/user/hooks";
import { useModalTools } from "@ui/modals/modalContext";
import { SecondaryButton } from "@ui/components/buttons/secondaryButton";
import { GroupMemberAccessModal } from "@ui/components/group/groupMemberAccessModal";

interface GroupAccessButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	groupId: string;
	groupName: string;
	groupType: GroupType;
	userId: string;
}
export const GroupAccessButton: React.FC<GroupAccessButtonProps> = ({
	groupId,
	groupName,
	groupType,
	userId,
	...htmlProps
}) => {
	const { result: member } = useGroupMember(groupId, userId);

	return member ? (
		<AccessGroupContent member={member} groupId={groupId} groupName={groupName} groupType={groupType} {...htmlProps} />
	) : null;
};

interface GroupAccessContent extends React.HTMLAttributes<HTMLButtonElement> {
	groupId: string;
	groupName: string;
	groupType: GroupType;
	member: GroupMember;
}
const AccessGroupContent: React.FC<GroupAccessContent> = ({ groupId, groupName, groupType, member, ...htmlProps }) => {
	const { createModal } = useModalTools();

	if (member.status !== "PENDING_HOST_ACCEPTANCE") {
		return null;
	}

	return (
		<SecondaryButton
			onClick={() =>
				createModal((close) => (
					<GroupMemberAccessModal
						close={close}
						groupType={groupType}
						groupId={groupId}
						groupName={groupName}
						member={member}
					/>
				))
			}
			{...htmlProps}
		>
			{I18n.t("group.grant.button")}
		</SecondaryButton>
	);
};
